import type { District } from "./districts";

export function WorldAtmosphere({ district }: { district: District }) {
  return (
    <div
      className="world-atmosphere"
      data-district={district.districtId}
      aria-hidden="true"
    >
      <div className="world-sky-bloom" />
      <div className="world-cloud world-cloud-far" />
      <div className="world-cloud world-cloud-near" />
      <div className="world-mist world-mist-one" />
      <div className="world-mist world-mist-two" />
      <div className="world-weather-particles">
        {Array.from({ length: 18 }, (_, index) => (
          <i key={index} />
        ))}
      </div>
      <div className="world-lens-haze" />
      <div className="world-film-grain" />
    </div>
  );
}
